import { Pipe } from '@angular/core';
var IsNotEqualToPipe = (function () {
    function IsNotEqualToPipe() {
    }
    IsNotEqualToPipe.prototype.transform = function (input, other) {
        // tslint:disable-next-line:triple-equals
        return input != other;
    };
    IsNotEqualToPipe.decorators = [
        { type: Pipe, args: [{ name: 'isNotEqualTo' },] },
    ];
    /** @nocollapse */
    IsNotEqualToPipe.ctorParameters = function () { return []; };
    return IsNotEqualToPipe;
}());
export { IsNotEqualToPipe };
//# sourceMappingURL=is-not-equal-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-not-equal-to.js
// module id = 249
// module chunks = 4